import { defaultMetaTransformer, render, renderMarkRule, renderNodeRule, } from 'datocms-structured-text-generic-html-renderer';
import { RenderError, isBlock, isInlineItem, isItemLink, isStructuredText, } from 'datocms-structured-text-utils';
import React, { cloneElement, isValidElement } from 'react';
export { renderNodeRule, renderMarkRule, RenderError };
// deprecated
export { renderNodeRule as renderRule };
export const defaultAdapter = {
    renderNode: React.createElement,
    renderFragment: (children, key) => React.createElement(React.Fragment, { key: key }, children),
    renderText: (text, key) => text,
};
export function appendKeyToValidElement(element, key) {
    if (isValidElement(element) && element.key === null) {
        return cloneElement(element, { key });
    }
    return element;
}
export function StructuredText({ data, renderInlineRecord, renderLinkToRecord, renderBlock, renderText, renderNode, renderFragment, customMarkRules, customRules, customNodeRules, metaTransformer, }) {
    const result = render(data, {
        adapter: {
            renderText: renderText || defaultAdapter.renderText,
            renderNode: renderNode || defaultAdapter.renderNode,
            renderFragment: renderFragment || defaultAdapter.renderFragment,
        },
        metaTransformer,
        customMarkRules,
        customNodeRules: [
            renderNodeRule(isInlineItem, ({ node, key }) => {
                if (!renderInlineRecord) {
                    throw new RenderError(`The Structured Text document contains an 'inlineItem' node, but no 'renderInlineRecord' prop is specified!`, node);
                }
                if (!(isStructuredText(data) && data.links)) {
                    throw new RenderError(`The document contains an 'itemLink' node, but the passed data prop is not a Structured Text GraphQL response, or data.links is not present!`, node);
                }
                const item = data.links.find((item) => item.id === node.item);
                if (!item) {
                    throw new RenderError(`The Structured Text document contains an 'inlineItem' node, but cannot find a record with ID ${node.item} inside data.links!`, node);
                }
                return appendKeyToValidElement(renderInlineRecord({ record: item }), key);
            }),
            renderNodeRule(isItemLink, ({ node, key, children }) => {
                if (!renderLinkToRecord) {
                    throw new RenderError(`The Structured Text document contains an 'itemLink' node, but no 'renderLinkToRecord' prop is specified!`, node);
                }
                if (!(isStructuredText(data) && data.links)) {
                    throw new RenderError(`The document contains an 'itemLink' node, but the passed data prop is not a Structured Text GraphQL response, or data.links is not present!`, node);
                }
                const item = data.links.find((item) => item.id === node.item);
                if (!item) {
                    throw new RenderError(`The Structured Text document contains an 'itemLink' node, but cannot find a record with ID ${node.item} inside data.links!`, node);
                }
                return appendKeyToValidElement(renderLinkToRecord({
                    record: item,
                    children: children,
                    transformedMeta: node.meta
                        ? (metaTransformer || defaultMetaTransformer)({
                            node,
                            meta: node.meta,
                        })
                        : null,
                }), key);
            }),
            renderNodeRule(isBlock, ({ node, key }) => {
                if (!renderBlock) {
                    throw new RenderError(`The Structured Text document contains a 'block' node, but no 'renderBlock' prop is specified!`, node);
                }
                if (!(isStructuredText(data) && data.blocks)) {
                    throw new RenderError(`The document contains an 'block' node, but the passed data prop is not a Structured Text GraphQL response, or data.blocks is not present!`, node);
                }
                const item = data.blocks.find((item) => item.id === node.item);
                if (!item) {
                    throw new RenderError(`The Structured Text document contains a 'block' node, but cannot find a record with ID ${node.item} inside data.blocks!`, node);
                }
                return appendKeyToValidElement(renderBlock({ record: item }), key);
            }),
            ...(customNodeRules || customRules || []),
        ],
    });
    if (typeof result === 'string') {
        return React.createElement(React.Fragment, null, result);
    }
    return result || null;
}
//# sourceMappingURL=index.js.map